export default __webpack_public_path__ + "static/media/alarma.9b8fab82.svg";